import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { SnapshotService } from '../../Services/snapshot.service';
import * as _ from 'lodash';
import { CustomsnapshotService } from '../../Services/customsnapshot.service';
import { LoaderService } from 'src/app/common/services/loader.service';

@Component({
  selector: 'app-custom-widget-output',
  templateUrl: './custom-widget-output.component.html',
  styleUrls: ['./custom-widget-output.component.css']
})
export class CustomWidgetOutputComponent implements OnChanges {
  hideCharts: boolean = false;

  constructor(public _configService: SnapshotService, private _configCustomService: CustomsnapshotService, private loader: LoaderService) {

  }
  @Input() outputData: any = {};
  @Input() sigIndex:string = '';
  @Output() pageCounterChanged = new EventEmitter<number>();

  ngOnChanges(changes: SimpleChanges) {
    sessionStorage.setItem('dataLoaded','true');
    console.log("outputData", this._configService.standardSnapOutputData);
    //Perform an operation if either pageData or widgetData changes
    if (changes['outputData']) {
      this.pageCount = this._configCustomService.pageCount;
      if (Object.keys(changes['outputData'].currentValue).length != 0) {
       this.outputDataRefresh();
      }
    }

    if(changes['sigIndex'] && this.sigIndex != 'sig'){
      if(Object.keys(this.outputData).length > 0){
      this.outputDataRefresh();
      }
    }
  }

 outputDataRefresh(){
  this.loader.showLoader();
  this.hideCharts = true;
  this.data = [];
  this.gridData =[];
  this.outputPageData = [];
  this.handleSectionOrSubsectionChange();

 }

  outputPageData: any = [];
  datafromLayout: any = [];
  data: any = [];
  pagesConfiguredFromLayout: any;
  totalNumberOfCharts: number = 0;
  columnPerRowCount: number = 0;
  baseSelected: string = "total base"
  //  chartList: {
  //   widgetName: string,
  //   image: string
  // }[] = [];
  chartList: any[] = [];
  gridTempleteColumns: string = "";

  handleSectionOrSubsectionChange() {
    this.chartList = [];
    this.pageCount = this._configCustomService.pageCount;//on change of section/subsection move to page 1
    this.disableLeftClick = true;
    this.disableRightClick = false;
    this.updateNavigationButtonsState();
    let pages = [];
    for (let i = 0; i < this.outputData.pageData.length; i++) {
      pages.push({
        page: this.outputData.pageData[i].key,
        selectedLayout: this.outputData.pageData[i].value, // Default value will be `null`
        disabled: false,
        dropdownOpen: false, // Add a flag to track dropdown state
        layout: [
          { label: 'Select a layout', value: null, selected: false },
          {
            label: '6 Widget Layout', value: 6, url: "../../../../../assets/ImagesSnapshot/Public/sixWidget_inactive.png",
            activeurl: "../../../../../assets/ImagesSnapshot/Public/sixWidget_active.png", selected: this.outputData.pageData[i].value == 6 ? true : false
          },
          {
            label: '4 Widget Layout', value: 4, url: "../../../../../assets/ImagesSnapshot/Public/fourWidget_inactive.png",
            activeurl: "../../../../../assets/ImagesSnapshot/Public/fourWidget_active.png", selected: this.outputData.pageData[i].value == 4 ? true : false
          }
        ],
      });
    }
    this.datafromLayout = pages;

    let sum = 0;
    let count = 0;
    this.datafromLayout.forEach((val: any) => {
      if (val.selectedLayout != null) {
        sum = sum + val.selectedLayout;
        count++;
      }
    })
    console.log(sum)
    //If no. of pages configured in layout is only one then disable right pagination click
    if (count == 1) {
      this.disableRightClick = true;
    }
    //debugger;
    //this.totalNumberOfCharts=this.snapShotService.LayoutDiv;
    this.pagesConfiguredFromLayout = count;
    this.totalNumberOfCharts = sum;
    this.columnPerRowCount = sum;


    for (let i = 0; i < this.totalNumberOfCharts; i++) {
      this.chartList.push({
        customizationProperties: "",
        metric: [],
        previewChartPostion: -1,
        widgetParentChartType: "",
        widget_name: "",
        widgetchart_name: ""
      });
    }

    //Adding widget details in chartList
    for (let i = 0; i < this.outputData.widgetData.length; i++) {
      if (this.outputData.widgetData[i].previewChartPostion == 0) {
        continue;
      }
      this.chartList[this.outputData.widgetData[i].previewChartPostion - 1] = this.outputData.widgetData[i];
    }
  this.hideCharts = true;
  

  
    setTimeout(() => {
          this.createInitialChartList();
      this.data = this._configService.selectedcompareacrossOption.includes("Multiple") ? this.paginatedDataMultiple() : this.paginatedData();
      if (this.data.length == 1 && this.data[0].widgetchart_name == "FUNNEL CHART") {
        this.prepareGridForMultiFunnel(this.data[0]);
      }

     this.hideCharts = false;
     this.loader.hideLoader();
    }, 1000)
    console.log("customData:", this.data);
  }
  createInitialChartList() {
    // ;
    // for (let i = 0; i < this.totalNumberOfCharts; i++) {
    //   this.chartList.push({
    //     widgetName: "",
    //     image: ""
    //   });
    // }
    //debugger;
    //Based on page number assign this.columnPerRowCount
    let page = this.datafromLayout.filter((item: any) => {
      return JSON.stringify(item).includes("Page " + this.pageCount)
    })
    if (page.length > 0) {
      this.columnPerRowCount = page[0].selectedLayout;

      this.gridTempleteColumns = "";
      for (let i = 0; i < (this.columnPerRowCount / 2); i++) {
        this.gridTempleteColumns += this.calculateValuePerDivision((this.columnPerRowCount / 2)) + "% ";
      }
      console.log('gridTempleteColumns', this.gridTempleteColumns)
    }
  }
  calculateValuePerDivision(numDivs: any) {
    const k = 99; // considering for 2 always 27.5.So reciprocal method: 27.5=k/2=>55.
    //so now for 3 it will be 55/3 ,for 4 it will be 55/4 and so on....
    return k / numDivs;
  }
  outputdata: any;//dummy
  paginatedData() {
    this.outputdata = this._configService.standardSnapOutputData; //remove later
    //debugger;
    let start = 0;
    if (this.pageCount == 0) {
      start = 0;
    } else {
      for (let i = 0; i < this.pageCount - 1; i++) {
        start = start + this.datafromLayout[i].selectedLayout;
      }
    }
    // const start = (this.pageCount - 1) * this.columnPerRowCount;
    const end = start + this.columnPerRowCount;
    let chartlist = this.chartList.slice(start, end);
    let pageCounter = 1;
    let item = chartlist;
    let items = _.cloneDeep(chartlist);

    items.forEach((item: any) => {
      item.metric.forEach((itemLev1: any) => {

        if (itemLev1.metric_group == '' && itemLev1.metric_value.length > 0) {
          let allMetricsNull = true;
          itemLev1.metric_value.forEach((metric: any) => {
            const outputRow = _.cloneDeep(this.outputdata.find((row: any) => row.rowChild.includes(metric.metricName) && row.widgetNumber == item.widgetNumber && item.widgetName == row.widgetName));
            if (this.baseSelected.toLowerCase() != "total base" ? outputRow?.answerWeightedShare !== null : outputRow?.totalWeightedShare !== null) {
              allMetricsNull = false;
            }
          });
          if (allMetricsNull) {
            item.metric = [];
            item.noData = true;
          }
        }
        else if (itemLev1.metric_group != '' && itemLev1.metric_value.length == 0) {
          let allMetricsNull = true;
          const metrics = this._configService.standardSnapOutputData.filter((row: any) => row.widgetNumber == item.widgetNumber && item.widgetName == row.widgetName);
          if (metrics.length > 0) {
            metrics.forEach((metric: any, index: number) => {

              if (this.baseSelected.toLowerCase() != "total base" ? metric?.answerWeightedShare !== null : metric?.totalWeightedShare !== null) {
                allMetricsNull = false;
              }
            });
            if (allMetricsNull) {
              item.metric = [];
              item.noData = true;
            }
          }
        }
        else if (itemLev1.metric_group == '' && itemLev1.metric_value.length == 0) {
          item.metric = [];
        }
      })
    });
    this._configCustomService.pageCount = this.pageCount;
    console.log("WidgetOutput", items)
    return items;
  }

  paginatedDataMultiple() {
    this.outputdata = this._configService.standardSnapOutputData; //remove later
    //debugger;
    let start = 0;
    if (this.pageCount == 0) {
      start = 0;
    } else {
      for (let i = 0; i < this.pageCount - 1; i++) {
        start = start + this.datafromLayout[i].selectedLayout;
      }
    }
    // const start = (this.pageCount - 1) * this.columnPerRowCount;
    const end = start + this.columnPerRowCount;
    let chartlist = this.chartList.slice(start, end);
    let pageCounter = 1;
    let item = chartlist;
    let items = _.cloneDeep(chartlist);

    items.forEach((item: any) => {
      item.metric.forEach((itemLev1: any) => {
        if (itemLev1.metric_group == '' && itemLev1.metric_value.length > 0) {
          let allMetricsNull = true;
          itemLev1.metric_value.forEach((metric: any) => {
            const outputRow = _.cloneDeep(this.outputdata.find((row: any) => row.rowChild.includes(metric.option) && row.colChild.includes(metric.colChild) && row.widgetNumber == item.previewChartPostion && item.widget_name == row.widgetName));
            if (this.baseSelected.toLowerCase() != "total base" ? outputRow?.answerWeightedShare !== null : outputRow?.totalWeightedShare !== null) {
              allMetricsNull = false;
            }
          });
          if (allMetricsNull) {
            item.metric = [];
            item.noData = true;
          }
        }
        else if (itemLev1.metric_group != '' && itemLev1.metric_value.length == 0) {
          let allMetricsNull = true;
          const metrics = this._configService.standardSnapOutputData.filter((row: any) => row.widgetNumber == item.widgetNumber && item.widgetName == row.widgetName);
          if (metrics.length > 0) {
            metrics.forEach((metric: any, index: number) => {

              if (this.baseSelected.toLowerCase() != "total base" ? metric?.answerWeightedShare !== null : metric?.totalWeightedShare !== null) {
                allMetricsNull = false;
              }
            });
            if (allMetricsNull) {
              item.metric = [];
              item.noData = true;
            }
          }
        }
        else if (itemLev1.metric_group == '' && itemLev1.metric_value.length == 0) {
          item.metric = [];
        }
      })
    });
    this._configCustomService.pageCount = this.pageCount;
    console.log("WidgetOutput", items)
    return items;
  }


  //----------Handling pagination counter---------
  pageCount = 1;
  disableLeftClick = false;
  disableRightClick = false;
  Paginate(side: string) {
    if (side == 'left') {
      const newPageData = { page: this.pageCount, data: this.data }; // Replace with your page and data
      const pageIndex = this.outputPageData.findIndex((item: any) => item.page === newPageData.page);
      if (pageIndex !== -1) {
        // Page exists, update the data
        this.outputPageData[pageIndex].data = newPageData.data;
      } else {
        // Page does not exist, append the new entry
        this.outputPageData.push(newPageData);
      }
      if (this.pageCount == 2) {
        this.pageCount--;
        this.createInitialChartList();
        // this.data = this._configService.selectedcompareacrossOption.includes("Multiple") ? this.paginatedDataMultiple() : this.paginatedData();
        let isPage = this.outputPageData.findIndex((item: any) => item.page === this.pageCount);
        if (isPage == -1) {
          this.data = this._configService.selectedcompareacrossOption.includes("Multiple") ? this.paginatedDataMultiple() : this.paginatedData();
        }
        else {
          this.data = this.outputPageData[isPage].data;
        }
        this.disableLeftClick = true;
        this.disableRightClick = false;
      }
      else {
        this.disableLeftClick = false;
        this.disableRightClick = false;
        this.pageCount--;
        this.createInitialChartList();
        // this.data = this._configService.selectedcompareacrossOption.includes("Multiple") ? this.paginatedDataMultiple() : this.paginatedData();
        let isPage = this.outputPageData.findIndex((item: any) => item.page === this.pageCount);
        if (isPage == -1) {
          this.data = this._configService.selectedcompareacrossOption.includes("Multiple") ? this.paginatedDataMultiple() : this.paginatedData();
        }
        else {
          this.data = this.outputPageData[isPage].data;
        }
      }

    }
    else if (side == 'right') {
      // if (this.pageCount == (Math.ceil(this.totalNumberOfCharts / this.columnPerRowCount) - 1)) {
      const newPageData = { page: this.pageCount, data: this.data }; // Replace with your page and data
      const pageIndex = this.outputPageData.findIndex((item: any) => item.page === newPageData.page);
      if (pageIndex !== -1) {
        // Page exists, update the data
        this.outputPageData[pageIndex].data = newPageData.data;
      } else {
        // Page does not exist, append the new entry
        this.outputPageData.push(newPageData);
      }
      if (this.pageCount == (this.pagesConfiguredFromLayout - 1)) {
        this.pageCount++;
        this.createInitialChartList();
        this.disableRightClick = true;
        let isPage = this.outputPageData.findIndex((item: any) => item.page === this.pageCount);
        if (isPage == -1) {
          this.data = this._configService.selectedcompareacrossOption.includes("Multiple") ? this.paginatedDataMultiple() : this.paginatedData();
        }
        else {
          this.data = this.outputPageData[isPage].data;
        }
        this.disableLeftClick = false;
      }
      else {
        ;
        this.pageCount++;
        this.createInitialChartList();
        this.disableLeftClick = false;
        this.disableRightClick = false;
        // this.data = this._configService.selectedcompareacrossOption.includes("Multiple") ? this.paginatedDataMultiple() : this.paginatedData();
        let isPage = this.outputPageData.findIndex((item: any) => item.page === this.pageCount);
        if (isPage == -1) {
          this.data = this._configService.selectedcompareacrossOption.includes("Multiple") ? this.paginatedDataMultiple() : this.paginatedData();
        }
        else {
          this.data = this.outputPageData[isPage].data;
        }
      }
    }

    this.pageCounterChanged.emit(this.pageCount);
    console.log(this.data);
    if (this.data.length == 1 && this.data[0].widgetchart_name == "FUNNEL CHART") {
      this.prepareGridForMultiFunnel(this.data[0]);
    }
    return;
  }

  updateNavigationButtonsState() {
    // Enable/disable navigation buttons based on pageCount
    this.disableLeftClick = this.pageCount <= 1; // Disable left if on the first page
    this.disableRightClick = this.pageCount >= this.pagesConfiguredFromLayout; // Disable right if on the last page
  }


  // elementClickedStatus(event: any) {
  //   const updatedData = this.data.map((d: any) => {
  //     if (d == event.data) {
  //       if (event.key == "sort") {
  //         if(event.value=="ascending"){
  //           d.metric.forEach((dd:any)=>{
  //             dd.metric_value[0].data.sort((a:any, b:any) => a.data - b.data);
  //           })
  //         }
  //       }
  //       else {
  //         let m = JSON.parse(d.customizationProperties);
  //         m[event.key] = event.value;
  //         return {
  //           ...d,
  //           customizationProperties: JSON.stringify(m),
  //         };
  //       }
  //     }
  //     return d;
  //   });
  //   this.data = [...updatedData];
  // }

  originalData: any[] = [..._.cloneDeep(this.data)]; // Initialize with the original data

  elementClickedStatus(event: any) {
    console.log(event);

    const updatedData = this.data.map((d: any) => {
      if (d === event.data) {
        if (event.key === "sort" && d.widgetchart_name != "Table") {
          const customizationProps = JSON.parse(d.customizationProperties || '{}');
          customizationProps[event.key] = event.value;
          if (event.value === "ascending" || event.value === "descending") {
            if (this._configService.selectedSnapshotType.toLowerCase().includes("multi")) {
              return {
                ...d,
                customizationProperties: JSON.stringify(customizationProps),
                metric: d.metric.map((dd: any) => ({
                  ...dd,
                  metric_value: dd.metric_value.map((mv: any) => ({
                    ...mv,
                    data: [...mv.data].sort((a: any, b: any) =>
                      event.value === "ascending" ? a.data - b.data : b.data - a.data
                    ),
                  })),
                })),
              };
            }
            else {
              console.log(d);

              return {
                ...d,
                customizationProperties: JSON.stringify(customizationProps),
                metric: d.metric.map((dd: any) => {
                  // Sort the metric_value items based on the first item in the data array
                  const sortedMetricValue = [...dd.metric_value].sort((a: any, b: any) => {
                    const aData = a.data[0]?.data; // Access the 'data' key of the first item in the data array
                    const bData = b.data[0]?.data; // Same for b

                    // Check if both aData and bData exist and compare them, else default to 0
                    if (aData !== undefined && bData !== undefined) {
                      return event.value === "ascending" ? aData - bData : bData - aData; // Ascending order based on the 'data' value
                    }
                    return 0; // Default to no sort if comparison cannot be made
                  });

                  return {
                    ...dd,
                    metric_value: sortedMetricValue, // Set the sorted metric_value array
                  };
                }),
              };

            }
          } else if (event.value === "default") {
            // Restore the original data for this specific item
            return {
              ...d,
              customizationProperties: JSON.stringify(customizationProps),
              metric: d.metric.map((dd: any) => ({
                ...dd,
                metric_value: dd.metric_value.map((mv: any) => ({
                  ...mv,
                  data: [...mv.data].sort((a: any, b: any) =>
                    a.defaultIndex - b.defaultIndex
                  ), // Sort by 'defaultIndex'
                }))
              }))
            };
          }
        } else {
          // Handle customizationProperties updates
          const customizationProps = JSON.parse(d.customizationProperties || '{}');
          customizationProps[event.key] = event.value;
          console.log(customizationProps);
          return {
            ...d,
            customizationProperties: JSON.stringify(customizationProps),
          };
        }
      }
      return d;
    });
    this.data = [...updatedData];
    this._configService.newCustomizationData = this.data;
  }

  gridData: any[] = [];
  prepareGridForMultiFunnel(customData: any) {
    customData.metric[0].metric_value[0].data.forEach((d: any) => {
      // this.brandList.push(d.colChild);
      this.gridData.push({
        header: d.colChild,
        data: customData
      })
    })
  }

}
